import React, { FC } from 'react';
import { capitalize } from 'lodash';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useTranslation } from 'app/lang';
import { useFeatureFlag } from 'app/lib/feature-flags';
import { getUniversalEnv } from 'app/lib/get-universal-env';
import { ROUTE_PATH } from 'app/lib/routing/constants';
import Header from 'app/modules/Layout/Header';
import { getBrandName } from 'app/packages/brand';
import { getBackendServerUrl } from 'app/ssr/utils';
import { QRCode } from 'app/widgets/QRCode';

import dictionary from './DesktopLayout.dictionary.json';

import styles from './DesktopLayout.module.scss';

export const DesktopLayout: FC = () => {
  const { t } = useTranslation();
  const instructionsURL = `${getBackendServerUrl()}${ROUTE_PATH.DOWNLOAD}`;
  const isQRtoInstructions = useFeatureFlag(FeatureFlag.QR_TO_INSTRUCTIONS);
  const mobileWebAppURL = getUniversalEnv('MOBILE_WEB_APP_URL');

  return (
    <>
      <Header />

      <div className={styles.content}>
        {mobileWebAppURL && (
          <QRCode value={isQRtoInstructions ? instructionsURL : mobileWebAppURL}
                  className={styles.code}
                  size={488}
                  searchParams={{ from: 'download_page' }} />
        )}
        <h1 className={styles.title}>
          {t(dictionary.title, { brand: capitalize(getBrandName()) })}
        </h1>
      </div>
    </>
  );
};
